// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"331":"45351764","663":"e2a1ec17"}[chunkId] + ".css";
};